/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Switch_FailedInputs */

const en_role_switch_failed = /** @type {(inputs: Role_Switch_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to switch role`)
};

const es_role_switch_failed = /** @type {(inputs: Role_Switch_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cambiar el rol`)
};

/**
* | output |
* | --- |
* | "Failed to switch role" |
*
* @param {Role_Switch_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_switch_failed = /** @type {((inputs?: Role_Switch_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Switch_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_switch_failed(inputs)
	return es_role_switch_failed(inputs)
});